import { Notification, Severity } from './notification.model';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ClientLogService } from '../../services/client.log.service';
import { TranslationService } from '../../services/translation.service';

@Injectable()
export class NotificationService {
  public messages: Array<Notification> = [];

  gcTime = 15000;
  messageAutoClose = 10000;

  constructor(private clientLogService: ClientLogService, private translationService: TranslationService) {
    setInterval(() => {
      this.messages = this.messages.filter(m => m.Acknowledged !== true);
    }, this.gcTime);
  }

  private pushMessage(message: Notification): void {
    this.messages.unshift(message);
  }

  public showNotification(message: string, severity: Severity, autoAcknowledge: boolean = true, detail?: string, sender?: string, isCentered?: boolean, messageAutoClose?: number): Notification {
    if (!message) { throw EvalError('Message should be set!'); }
    if (!severity) { throw EvalError('Severity should be set!'); }

    const mess = new Notification();

    if (severity == Severity.error) {
      message = this.translationService.translate(message);
      detail = this.translationService.translate(detail);
      this.clientLogService.create(message, detail).then(reference => mess.Reference = reference);
    }

    mess.Message = message;
    mess.Severity = severity;
    mess.AutoAcknowledge = autoAcknowledge;
    mess.Detail = detail;
    mess.Sender = sender || '';
    mess.IsCentered = isCentered;
    if (messageAutoClose) {
      this.messageAutoClose = messageAutoClose;
    }

    mess.Arrived = moment().toDate();

    if (mess.AutoAcknowledge) {
      setInterval(() => {
        mess.Acknowledged = true;
      }, this.messageAutoClose);
    }

    this.pushMessage(mess);
    return mess;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/notification.service/notification.service.ts